import { ErrorBoundary, IconButton, Tooltip } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { useBulkActionsButton } from "./useBulkActionsButton"

export function ArchiveDocumentsButton() {
  return (
    <ErrorBoundary renderError={Fallback}>
      <Suspense fallback={<Fallback />}>
        <ArchiveButton />
      </Suspense>
    </ErrorBoundary>
  )
}

function ArchiveButton() {
  const { action, disabled, tooltip, getSelectedDocuments } =
    useBulkActionsButton()

  function onClick() {
    const items = getSelectedDocuments().map((document) => ({
      documentId: document.id,
      versionId: document.versions[0]?.version_id ?? "",
      status: document.versions[0]?.status ?? ""
    }))

    action("archive", { items })
  }

  return (
    <Tooltip content={tooltip || "Archive"}>
      <IconButton
        icon="inventory"
        onClick={onClick}
        disabled={disabled}
        color="grey"
      />
    </Tooltip>
  )
}

function Fallback() {
  return <IconButton icon="inventory" disabled color="grey" />
}
